// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loyalty-filter {
  /* display: flex; */
  /* align-items: center; */
  margin: 1.875rem 0;
  /* justify-content: flex-end; */
}
.loyalty-filter h5 {
  font-size: 0.938rem !important;
}
.loyalty-filter .ant-input {
  /* width: auto; */
  /* margin-left: 0.625rem; */
  width: 100%;
}
.loyalty-filter button {
  /* margin-left: 0.313rem; */
  border-radius: 0 !important;
}

.loyalty-filter .filter-btn-div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/loyalty.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".loyalty-filter {\r\n  /* display: flex; */\r\n  /* align-items: center; */\r\n  margin: 1.875rem 0;\r\n  /* justify-content: flex-end; */\r\n}\r\n.loyalty-filter h5 {\r\n  font-size: 0.938rem !important;\r\n}\r\n.loyalty-filter .ant-input {\r\n  /* width: auto; */\r\n  /* margin-left: 0.625rem; */\r\n  width: 100%;\r\n}\r\n.loyalty-filter button {\r\n  /* margin-left: 0.313rem; */\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.loyalty-filter .filter-btn-div {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
